document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(Draggable, InertiaPlugin) 
  const sliderContainer = document.querySelector('.slider-container-inner');
  const sliderContents = document.querySelectorAll('.slider-content');
  const sliderNavItems = document.querySelectorAll('.slider-nav-item');

  // 获取滑块容器宽度
  let slideWidth = sliderContainer.clientWidth;

  // 生成 snap 位置数组
  const snapPositions = Array.from({ length: sliderContents.length }, (_, i) => -i * slideWidth);

  // 当前激活的索引
  let currentIndex = 0;
  // 定时器 ID
  let autoSlideTimer;
  // 自动切换间隔时间（单位：毫秒）
  const autoSlideInterval = 6000;
  // 自动切换开关
  let isAutoSlideEnabled = true;

  // 更新导航激活状态
  function updateNavActiveState() {
    sliderNavItems.forEach((item, index) => {
      if (index === currentIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  // 初始化导航激活状态
  updateNavActiveState();

  // 自动切换函数
  function autoSlide() {
    if (!isAutoSlideEnabled) return;
    if (currentIndex < sliderContents.length - 1) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    gsap.to(sliderContainer, {
      x: snapPositions[currentIndex],
      duration: 0.5,
      ease: "power2.out"
    });
    updateNavActiveState();
  }

  // 启动自动切换
  function startAutoSlide() {
    autoSlideTimer = setInterval(autoSlide, autoSlideInterval);
  }

  // 停止自动切换
  function stopAutoSlide() {
    clearInterval(autoSlideTimer);
  }

  // 封装初始化滑块的逻辑，方便复用
  function initSlider() {
    // 获取滑块容器宽度
    slideWidth = sliderContainer.clientWidth;
  
    // 生成 snap 位置数组
    snapPositions.length = 0;
    for (let i = 0; i < sliderContents.length; i++) {
      snapPositions.push(-i * slideWidth);
    }

    // 重置当前位置到第一张幻灯片
    gsap.set(sliderContainer, { x: snapPositions[currentIndex] });
  }

  // 点击导航切换滑块
  sliderNavItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      // 停止当前的自动切换定时器
      stopAutoSlide();
      currentIndex = index;
      gsap.to(sliderContainer, {
        x: snapPositions[currentIndex],
        duration: 0.5,
        ease: "power2.out"
      });
      updateNavActiveState();
      // 重新启动自动切换定时器
      startAutoSlide();
    });
  });

  let draggableInstance = Draggable.create(sliderContainer, {
    type: "x",
    edgeResistance: 0.75, 
    onClick: function () {
      console.log("clicked");
    },
    onDragStart: function () {
      isAutoSlideEnabled = false;
    },
    onDragEnd: function () {
      const currentX = this.x;
      const deltaX = currentX - snapPositions[currentIndex];
      // 设置切换阈值为滑块宽度的 10%
      const threshold = slideWidth * 0.1;
  
      if (deltaX < -threshold) {
        // 向左滑动超过阈值，切换到下一张
        if (currentIndex < sliderContents.length - 1) {
          currentIndex++;
        }
      } else if (deltaX > threshold) {
        // 向右滑动超过阈值，切换到上一张
        if (currentIndex > 0) {
          currentIndex--;
        }
      }
  
      gsap.to(sliderContainer, {
        x: snapPositions[currentIndex],
        duration: 0.5,
        ease: "power2.out"
      });
      updateNavActiveState();
      if (sliderContainer.matches(':hover')) {
        isAutoSlideEnabled = false;
      } else {
        isAutoSlideEnabled = true;
      }
    },
    snap : {
      x: snapPositions,
      duration: 0.3, 
      ease: "power1.out",
      onComplete: function () {
        currentIndex = snapPositions.indexOf(this.x);
        updateNavActiveState();
      }
    }
  });

  // 添加窗口大小变化监听事件
  window.addEventListener('resize', function() {
    // 使用防抖函数避免频繁触发
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initSlider, 200);
  });

  let resizeTimer;
  // 添加鼠标悬停暂停自动切换，鼠标离开恢复自动切换的逻辑
  sliderContainer.addEventListener('mouseenter', () => {
    isAutoSlideEnabled = false;
  });
  sliderContainer.addEventListener('mouseleave', () => {
    isAutoSlideEnabled = true;
    if (!autoSlideTimer) {
      startAutoSlide();
    }
  });


  // 初始化时调用一次
  initSlider();

  // 启动自动切换
  startAutoSlide();
});